import appStore from 'store';
import api from './api';
import { STATUS_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    billList: [],
    userRecords: [],
    audistCount: 0,
    userDetailTotal: 0,
    billTotal: 0,
    userWallet: [],
    pagination: { page: 1, size: 25 },
    userDetailPagination: { page: 1, size: 25 },
    billPagination: { page: 1, size: 25 },
    activeTab: '2'
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status]
        };
      });
    },
    setAudistCount(state, payload) {
      state.audistCount = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setUserDetailPagination(state, payload) {
      state.userDetailPagination = payload;
    },
    setBillPagination(state, payload) {
      state.billPagination = payload;
    },
    setUserRecords(state, payload) {
      state.userRecords = payload;
    },
    setUserDetailTotal(state, payload) {
      state.userDetailTotal = payload;
    },
    setBillTotal(state, payload) {
      state.billTotal = payload;
    },
    setBillList(state, payload) {
      state.billList = payload;
    },
    setUserWallet(state, payload) {
      state.userWallet = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data.list || []);
        commit('setAudistCount', data.totalCount || 0);
        commit('setPagination', { page: query.page, size: query.size });
      });
    },
    // eslint-disable-next-line
    approve({ commit }, data) {
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    cancel({ commit }, data) {
      return new Promise(resolve => {
        api.cancelAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    getUserRecords({ commit }, query) {
      api.getUserRecords(query).then(({ data }) => {
        commit('setUserRecords', data.list || []);
        commit('setUserDetailTotal', data.totalCount || 0);
        commit('setUserDetailPagination', {
          page: query.page,
          size: query.size
        });
      });
      api.getUserWallet(query.userId).then(({ data }) => {
        commit('setUserWallet', data);
      });
    },
    getBillList({ commit }, query) {
      api.getBillList(query).then(({ data }) => {
        commit('setBillList', data.list || []);
        commit('setBillTotal', data.totalCount || 0);
        commit('setBillPagination', {
          page: query.page,
          size: query.size
        });
      });
    },
    resetUserRecords({ commit }) {
      commit('setUserRecords', []);
      commit('setUserDetailTotal', 0);
      commit('setUserWallet', []);
      commit('setUserDetailPagination', {
        page: 1,
        size: 25
      });
      commit('setBillList', []);
      commit('setBillTotal', 0);
      commit('setBillPagination', {
        page: 1,
        size: 25
      });
    }
  }
};

appStore.registerModule('merchantAudit', store);
